var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidden(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye-slash",
    "data-name": "Icon awesome-eye-slash",
    d: "M12.5,15.625a5.6,5.6,0,0,1-5.582-5.2L2.82,7.258A13.019,13.019,0,0,0,1.386,9.43a1.264,1.264,0,0,0,0,1.14A12.529,12.529,0,0,0,12.5,17.5a12.133,12.133,0,0,0,3.043-.409l-2.027-1.568a5.63,5.63,0,0,1-1.016.1Zm12.258,2.27L20.44,14.557a12.939,12.939,0,0,0,3.174-3.987,1.264,1.264,0,0,0,0-1.14A12.529,12.529,0,0,0,12.5,2.5,12.037,12.037,0,0,0,6.745,3.972L1.776.132A.625.625,0,0,0,.9.241l-.767.987a.625.625,0,0,0,.11.877L23.224,19.868a.625.625,0,0,0,.877-.11l.767-.987a.625.625,0,0,0-.11-.877Zm-7.176-5.547-1.535-1.187A3.7,3.7,0,0,0,11.511,6.4a1.861,1.861,0,0,1,.364,1.1,1.822,1.822,0,0,1-.06.391L8.939,5.668A5.559,5.559,0,0,1,12.5,4.375,5.622,5.622,0,0,1,18.125,10a5.491,5.491,0,0,1-.543,2.348Z",
    transform: "translate(0 0)",
    fill: "#007681"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default __webpack_public_path__ + "static/media/hidden.85879b17ab57c3e022cec519da9ff2fe.svg";
export { ForwardRef as ReactComponent };